<template>
    <div class="contents">
        <div class="wrap">
            <section>
            <h2 class="page_title --view">포장입고 신청 등록</h2>
            </section>
            <section class="view">
            <div class="table_list">
                <table class="write">
                <colgroup>
                    <col width="200">
                    <col width="*">
                </colgroup>
                <tbody>
                    <tr>
                    <th><span class="emp">포장상품명</span></th>
                    <td>
                        <div class="form_inline">
                        <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.wrapperNm">
                        <button class="btn btn_md btn_blue" v-b-modal.wrapperSearchModal>검색</button>
                        </div>
                    </td>
                    </tr>        
                    <tr>
                    <th><span class="emp">입고수량</span></th>
                    <td>
                        <input type="number" class="form_control" placeholder="입력해주세요." v-model="regData.wrapperWrhsQnty">
                    </td>
                    </tr>                       
                    <tr>
                    <th><span>입고단가</span></th>
                    <td>
                        <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.wrhsPrice">
                    </td>
                    </tr>               
                </tbody>
                </table>
                <div class="bottom_box">
                <button class="btn btn_md btn_outline" @click="fn_move_page">목록</button>
                <div class="btn_box">
                    <!-- <button class="btn btn_md btn_gray">취소</button> -->
                    <button class="btn btn_md btn_darkblue" @click="fn_reg">저장</button>
                </div>
                </div>
            </div>
            </section>
        </div>
        <WrapperSearchModal 
            :title="'포장상품 검색'" 
            :searchName="'포장상품명'"
            :searchData="regData.wrapperNm"
            :btnRight="'닫기'"                          
            :oneBtn="true"
            :btnLeft="'적용'" 
            :filter="true"
            @callback="fn_callback"
        />
    </div>
</template>

<script>
    import axios from 'axios'
    import WrapperSearchModal from "@/modal/admin/wrapperSearch.vue"
    import commonUtil from "@/mixin/commonUtil";

  export default {
    name: 'WrapperWrhsMngtReg',
    mixins: [commonUtil],
    components: {      
      WrapperSearchModal,
    },
    data() {
        return {
            selected: null,
            regData : {
                wrapperWrhsCd : "",
                wrapperCd : "",
                wrapperNm : "",
                wrapperWrhsQnty : '',
                wrhsPrice : '',
                status : ''
            },
        }
    },
    created(){
        this.regData.status = this.$store.getters['commonStore/getStatus'];

        if(this.regData.status == 'M'){
          this.regData.wrapperWrhsCd = this.$store.getters['commonStore/getMainCode'];  
          this.fn_search(); 
        }
    },
    methods : {
        fn_callback (code,name){
			this.regData.wrapperCd = code;
			this.regData.wrapperNm = name;
		},
        fn_reg(){

            if(this.regData.wrapperCd == null || this.regData.wrapperCd == ''){
                alert("포장재를 선택해주세요");
                return;
            }

            if(this.regData.wrapperWrhsQnty == null || this.regData.wrapperWrhsQnty == ''){
                alert("포장 입고량을 입력해주세요");
                return;
            }


            console.log("@@@@ regData : %o",this.regData);

                axios.post("/api/admin/wrapperWrhs/regWrapperWrhs", 
                    this.regData
                ).then((res) => {
                console.log("@@@@ res : %o",res);

                alert("저장되었습니다");
                this.fn_move_page();
            })
            .catch((err) => console.log(err));

        
        },
        fn_move_page(){
			this.$store.dispatch('commonStore/setStatus', '');
			this.$router.push("/admin/wrapper/WrapperWrhsMngt");
		},
        fn_search(){

          let param = new Object();
          param.wrapperWrhsCd = this.regData.wrapperWrhsCd;

          console.log("@@@@ param : %o",param);

          axios
              .post("/api/admin/wrapperWrhs/getWrapperWrhsDetail", param)
              .then((res) => {
                  console.log("@@@@ dtl res : %o",res);
                
                  this.regData.wrapperWrhsCd = res.data.wrapper_wrhs_cd;
                  this.regData.wrapperCd = res.data.wrapper_cd;
                  this.regData.wrapperNm = res.data.wrapper_nm;
                  this.regData.wrapperWrhsQnty = res.data.wrapper_wrhs_qnty;
                  this.regData.wrhsPrice = res.data.wrhs_price;
                
                  
              })
              .catch((err) => console.log(err));
                
        },
    }
  }
</script>